module.exports = __webpack_public_path__ + "img/ennetix-xome-tab.be6e637b.png";